<div class="info-display layout">
  <div class="info-display__header">
    <iot-platform-ui-breadcrumb
      (back)="onBack()"
      [data]="$safeNavigationMigration((activeElement$ | async)?.data)"
      [icon]="$safeNavigationMigration((activeElement$ | async)?.icon)"
      [label]="$safeNavigationMigration((activeElement$ | async)?.label)"
      [loading]="siteLoading$ | async"
      [title]="$safeNavigationMigration((activeElement$ | async)?.title)"
    >
    </iot-platform-ui-breadcrumb>
  </div>
  <div class="info-display__content layout__wrapper max-w-4xl pt-8 pr-12 pb-8 pl-12 sm:mb-4 sm:p-4 xl:max-w-4xl">
    <router-outlet></router-outlet>
  </div>
</div>
